import React from 'react';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';

import './styles.css';

class CreatableValueSelect extends React.Component {
  handleChange = selectedOption => {
    if (this.props.onChange) {
      this.props.onChange(this.props.name, selectedOption);
    } else if (this.props.controlFunc) {
      this.props.controlFunc(selectedOption, this.props.name);
    }
  };

  handleBlur = () => {
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name, true, true);
    } else if (this.props.touchFunc) {
      this.props.touchFunc();
    }
  };

  handleCreateOption = value => {
    this.handleChange({ label: value, value: -2, __isNew__: true });
  };

  render() {
    const {
      value,
      options,
      name,
      label,
      required,
      placeholder,
      controlInputChangeFunc,
      isValid,
    } = this.props;

    const isRequired = required
      ? 'creatable-value-select__label-text creatable-value-select__label-text--required'
      : 'creatable-value-select__label-text';

    const customStyles = {
      control: base => ({
        ...base,
        borderColor: isValid ? '#a0a0a0' : '#f40',
      }),
    };

    return (
      <div className="creatable-value-select__wrapper">
        <label className="creatable-value-select__label" htmlFor={name}>
          <span className={isRequired}>{label}</span>
        </label>
        <CreatableSelect
          instanceId={Date.now()}
          styles={customStyles}
          value={value}
          isClearable
          isSearchable
          onChange={this.handleChange}
          onInputChange={controlInputChangeFunc}
          onCreateOption={this.handleCreateOption}
          name={name}
          options={options}
          className="creatable-value-select"
          classNamePrefix="creatable-value-select"
          placeholder={placeholder}
          onBlur={this.handleBlur}
        />
      </div>
    );
  }
}

CreatableValueSelect.propTypes = {
  options: PropTypes.array,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  controlFunc: PropTypes.func,
  onChange: PropTypes.func,
  controlInputChangeFunc: PropTypes.func,
  isValid: PropTypes.bool.isRequired,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  touchFunc: PropTypes.func,
};

CreatableValueSelect.defaultProps = {
  options: [],
  required: false,
};

export default CreatableValueSelect;
